import { styled } from '@grupoboticario/flora-react';
import { Select } from 'src/styles';

export default {
  Form: styled('form', {
    alignItems: 'center',
    background: 'transparent',
    display: 'flex',
    height: '32px',

    button: {
      height: '32px',
    },
  }),

  SelectWrapper: styled('div', {
    height: '32px',
    position: 'relative',
    span: {
      color: '$dark-dark',
      display: 'flex',
      position: 'absolute',
      borderRadius: '$medium',
      left: '2px',
      top: '3px',
      height: '26px',
      alignItems: 'center',
      background: '$light-light',
      padding: '$0 $3',
      fontSize: '12px',
      pointerEvents: 'none',
    },
  }),

  Select: styled(Select, {
    marginRight: '$1',
    height: '100%',
    minWidth: '110px',

    // using 16px minimum font size to prevent iOS from zoom in on focus
    fontSize: '16px',
  }),

  SelectLabel: styled('span', {
    display: 'none',
  }),
};
